/** 운영·개발 서비스와 로컬 미리보기에서 평가 메뉴와 라우트를 활성화한다. */
export function rcpsEnabledFor(host: string): boolean {
  return /^(value-agent(?:-dev)?\.deepsearch\.com|localhost|127\.0\.0\.1|\[::1\])$/i.test(
    host,
  );
}
export const RCPS_ENABLED =
  typeof window !== "undefined" && rcpsEnabledFor(window.location.hostname);
